module.exports = __webpack_public_path__ + "img/eye-open.89c3f917.svg";